<template>
    <div>
        <zm-row v-if="!isCreateTopic">
        <zm-select size="small" v-model="selectedTopic" filterable clearable class="describe-select"
            @change="refreshDetail" :loading="selectLoading" @visible-change="visibleChange">
            <zm-option v-for="item in topicList" :key="item" :value="item" :label="item"></zm-option>
        </zm-select>
        <zm-button size="small" style="margin-left: 5px" type="icon" icon="zm-icon-refresh" @click="refreshDetail"></zm-button>
        <zm-button size="small" style="margin-left: 5px" type="primary" plain @click="isCreateTopic = true" v-if="hasPermission">Create Topic</zm-button>
        <zm-button size="small" plain @click="showDownload" style="margin-left: 8px;" v-if="hasPermission">Download All</zm-button>
        <zm-button size="small" style="margin-left: 5px" type="primary" plain @click="jumpToGenerate" v-if="hasPermission">Generate Dashboard</zm-button>
        </zm-row>
        <topicDescribeDetail :channelId="id" :topicUrl="selectedTopic" ref="detail"
        v-if="selectedTopic" @refresh="refresh" @cancelCreateTopic="cancelCreateTopic"
        :isCreateTopic="isCreateTopic"></topicDescribeDetail>
        <zm-dialog title="Export Topics" :visible.sync="visible">
            <zm-form :model="form" :rules="rules" label-position="left" ref="form">
                <zm-form-item prop="batchSize">
                    <div slot="label">
                        <tip label="batchSize" id="kafka-topic-download-batchSize"></tip>
                    </div>
                    <zm-input-number size="small" v-model="form.batchSize" :min="1"></zm-input-number>
                </zm-form-item>
                <zm-form-item prop="requestTimeoutMs">
                    <div slot="label">
                        <tip label="requestTimeoutMs" id="kafka-topic-download-requestTimeoutMs"></tip>
                    </div>
                    <zm-input-number size="small" v-model="form.requestTimeoutMs" :min="1"></zm-input-number>
                </zm-form-item>
            </zm-form>
            <div slot="footer" class="dialog-footer">
                <zm-button size="small" @click="visible = false">Cancel</zm-button>
                <zm-button size="small" type="primary" @click="downloadTopics()" :loading="loading">Export</zm-button>
            </div>
        </zm-dialog>
    </div>
</template>
<script>
import topicDescribeDetail from './topicDescribeDetail'
import { getClusterTopics, downloadTopics } from '@/api/kafkaManage'
import tip from 'components/ToolTip/index'
export default {
    name: 'topicDescribe',
    components: {
        tip,
        topicDescribeDetail
    },
    data () {
        return {
            hasPermission: localStorage.role === 'SUPER_ADMIN' || localStorage.role === 'ADMIN',
            isCreateTopic: false,
            id: '',
            selectLoading: false,
            loading: false,
            topicList: [],
            selectedTopic: '',
            data: {},
            search: '',
            visible: false,
            form: {
                batchSize: 500,
                requestTimeoutMs: 30000
            },
            rules: {
                batchSize: [
                    { required: true, message: 'please enter batchSize', trigger: 'blur' }
                ],
                requestTimeoutMs: [
                    { required: true, message: 'please enter requestTimeoutMs', trigger: 'blur' }
                ]
            },
            pageable: {
                pageNumber: 1,
                pageSize: 10,
                total: 0
            }
        }
    },
    created () {
        this.id = this.$route.params.id
        if (localStorage.params && localStorage.params !== 'undefined' && localStorage.path === this.$route.path) {
            this.select = JSON.parse(localStorage.params).select
            this.selectedTopic = JSON.parse(localStorage.params).selectedTopic
            this.fetchData(false)
            this.refreshDetail()
        } else {
            this.fetchData(true)
        }
        localStorage.params = ''
        localStorage.path = this.$route.path
    },
    computed: {
        tableData () {
            if (this.search) {
                return this.data.partitions.filter(data => {
                    return Object.keys(data).some(key => {
                        return String(data[key]).toLowerCase().indexOf(this.search) > -1
                    })
                })
            }
            return this.data.partitions
        }
    },
    watch: {
        selectedTopic () {
            this.setURL()
        },
        search () {
            this.setURL()
        }
    },
    methods: {
        setURL () {
            const { selectedTopic, select } = this
            const data = { path: this.$route.path, selectedTopic, select }
            localStorage.path = this.$route.path
            localStorage.params = JSON.stringify(data)
        },
        refreshDetail () {
            this.$nextTick(() => {
                this.$refs.detail.fetchDescribe(this.selectedTopic)
            })
        },
        visibleChange (val) {
            if (val && !this.topicList.length) {
                this.fetchData(false)
            }
        },
        cancelCreateTopic () {
            this.isCreateTopic = false
        },
        refresh (newUrl) {
            this.isCreateTopic = false
            this.selectLoading = true
            getClusterTopics(this.id).then(response => {
                this.selectLoading = false
                this.topicList = response.topicUrls
                if (newUrl) {
                    this.selectedTopic = newUrl
                    this.refreshDetail()
                } else {
                    this.selectedTopic = this.topicList[0]
                    this.refreshDetail()
                }
            }).catch(() => {
                this.selectLoading = false
            })
        },
        showDownload () {
            this.visible = true
            this.form.batchSize = 500
            this.form.requestTimeoutMs = 30000
        },
        downloadTopics () {
            this.$refs.form.validate((valid) => {
                if (valid) {
                    this.$confirm('This will download all topics. Continue?', 'Warning', {
                        confirmButtonText: 'Download',
                        cancelButtonText: 'Cancel',
                        type: 'warning'
                    }).then(() => {
                        this.$message.info('Downloading, please wait..')
                        downloadTopics(this.id, this.form).then((res) => {
                            this.visible = false
                            let blob = new Blob([res], { type: 'application/vnd.ms-excel' })
                            var a = document.createElement('a')
                            a.href = URL.createObjectURL(blob)
                            a.download = 'topics_data.xlsx'
                            a.style.display = 'none'
                            document.body.appendChild(a)
                            a.click()
                            a.remove()
                        })
                    }).catch(() => {
                        this.$message({
                            type: 'info',
                            message: 'Download canceled'
                        })
                    })
                }
            })
        },
        fetchData (isCreated) {
            this.isCreateTopic = false
            this.selectLoading = true
            getClusterTopics(this.id).then(response => {
                this.selectLoading = false
                this.topicList = response.topicUrls
                if (isCreated) {
                    if (this.$route.query.topicUrl && this.topicList.indexOf(this.$route.query.topicUrl) > -1) {
                        this.selectedTopic = this.$route.query.topicUrl
                    } else {
                    this.selectedTopic = this.topicList[0]
                    }
                    // this.$nextTick(() => {
                    //     this.$refs.detail.fetchDescribe(this.selectedTopic)
                    // })
                    // this.fetchDescribe(this.topicList[0])
                }
            }).catch(() => {
                this.selectLoading = false
            })
        },
        jumpToGenerate () {
            this.$router.push('/dashboard/manage/generate/' + this.id + '/' + this.selectedTopic)
        }
    }
}
</script>
<style>
.describe-form {
    margin: 10px;
    color: #747487;
    padding-right: 80px;
}
.search-input{
    float: right;
    margin: 10px;
    width: 200px;
}
.describe-container {
    min-height: 300px;
}
.config-form {
    line-break: anywhere;
    word-break: break-all;
}
.describe-select {
    width: 500px;
}
</style>
